import { render, staticRenderFns } from "./buttons-admin.vue?vue&type=template&id=41bd150a"
import script from "./buttons-admin.vue?vue&type=script&lang=ts"
export * from "./buttons-admin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports